import React from 'react'
import { Box, InputAdornment, TextField } from '@mui/material'
import { formatMoneyUpToSixDecimals } from '../../../helpers/utils'
import {
  SPECIAL_PRICE_SCALE_FIELD_SX,
  SPECIAL_PRICE_SHOW_SCALE_LABELS,
  SPECIAL_PRICE_SHOW_SCALE_SECTION_DESCRIPTION,
  SPECIAL_PRICE_SHOW_SCALE_SECTION_TITLE
} from '../constant/specialPriceViewConstants'
import {
  buildScaleFieldLabel,
  getScaleMaxQtyValue
} from '../helpers/specialPriceShowHelpers'

const SpecialPriceScaleList = ({ details }) => {
  return (
    <div className="task-form-section">
      <div className="title-promos-form">
        <b>{SPECIAL_PRICE_SHOW_SCALE_SECTION_TITLE}</b>
      </div>
      <p>{SPECIAL_PRICE_SHOW_SCALE_SECTION_DESCRIPTION}</p>
      <hr className="hr-special-form" />

      <div className="special-price-scale-list">
        {(details.ranges || []).map((range, index) => (
          <Box className="special-price-scale-row" key={`${range.position}-${range.min_qty}`}>
            <div className="special-price-scale-index special-price-scale-index--top">
              <span className="scale-number-circle">{index + 1}</span>
            </div>

            <Box className="special-price-scale-group special-price-scale-group--wide">
              <TextField
                fullWidth
                label={buildScaleFieldLabel(SPECIAL_PRICE_SHOW_SCALE_LABELS.minSale, details.sales_unit)}
                value={String(range.min_qty ?? '')}
                InputLabelProps={{ shrink: true }}
                disabled
                variant="outlined"
                sx={SPECIAL_PRICE_SCALE_FIELD_SX}
              />
            </Box>

            <div className="special-price-scale-separator special-price-scale-separator--dash" />

            <Box className="special-price-scale-group special-price-scale-group--wide">
              <TextField
                fullWidth
                label={buildScaleFieldLabel(SPECIAL_PRICE_SHOW_SCALE_LABELS.maxSale, details.sales_unit)}
                value={getScaleMaxQtyValue(range.max_qty)}
                InputLabelProps={{ shrink: true }}
                disabled
                variant="outlined"
                sx={SPECIAL_PRICE_SCALE_FIELD_SX}
              />
            </Box>

            <div className="special-price-scale-separator">
              {SPECIAL_PRICE_SHOW_SCALE_LABELS.separator}
            </div>

            <Box className="special-price-scale-group special-price-scale-group-price">
              <TextField
                fullWidth
                label={SPECIAL_PRICE_SHOW_SCALE_LABELS.offerPrice}
                value={formatMoneyUpToSixDecimals(range.special_price)}
                InputLabelProps={{ shrink: true }}
                disabled
                variant="outlined"
                sx={SPECIAL_PRICE_SCALE_FIELD_SX}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>
                }}
              />
            </Box>
          </Box>
        ))}
      </div>
    </div>
  )
}

export default SpecialPriceScaleList
